import { Card, Grid } from "@mui/material";
import React from "react";
import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { useFormContext } from "react-hook-form";
import GridItem from "../../../../components/Grid/GridItem";
import GridContainer from "../../../../components/Grid/GridContainer";

function Vectron() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <FormTextTC name={"apiaccounts__ecashVenueId"} tKey={"E-Cash venue id"} />
            <FormTextTC name={"apiaccounts__ecashVenueUser"} tKey={"E-Cash username"} />
            <FormTextTC name={"apiaccounts__ecashVenuePass"} tKey={"E-Cash password"} />
            <FormTextTC name={"apiaccounts__ecashAuthToken"} tKey={"E-Cash authtoken"} />
            <FormSwitchTC name={"apiaccounts__ecashMenucardSalesarea"} tKey={"E-Cash menucard salesarea"} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <GridContainer>
              <GridItem xs={12}>
                <h3>
                  <TranslationWrapper
                    tDefault={"E-Cash api endpoints"}
                    tKey={"vestigingen.form.ecash.endpointsTitle"}
                  />
                </h3>
              </GridItem>
              <GridItem xs={12}>
                https://jamezz.app/core/ecash/Orders/GetOrders/[venueId]
                <br />
                https://jamezz.app/core/ecash/Orders/ConfirmOrder/[venueId]
                <br />
                https://jamezz.app/core/ecash/Venues/PushMenu/[venueId]
                <br />
                https://jamezz.app/core/ecash/Venues/PushTables/[venueId]
                <br />
              </GridItem>
            </GridContainer>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Vectron;
